import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ButtonConfig,
  buttonsStaticConfig, KeyValue,
  SystemNotification
} from '../../../modules/global';
import {BehaviorSubject, Subject} from 'rxjs';
import {debounceTime, takeUntil, tap} from 'rxjs/operators';
import { DialogContainerComponent } from '../../../modules/shared/components/dialog-container/dialog-container.component';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TemplatePresenterComponent } from '../../../modules/shared/components/template-presenter/template-presenter.component';

@Component({
    selector: 'slm-notification-alert-dialog',
    templateUrl: './notification-alert-dialog.component.html',
    imports: [DialogContainerComponent, NgIf, NgFor, CdkScrollable, NgSwitch, NgSwitchCase, TemplatePresenterComponent, AsyncPipe]
})
export class NotificationAlertDialogComponent implements OnInit, OnDestroy {
  readonly dialogRef = inject<MatDialogRef<NotificationAlertDialogComponent>>(MatDialogRef);
  data = inject<{
    items: Array<SystemNotification>;
    showAll?: false;
}>(MAT_DIALOG_DATA);

  public buttons: Array<ButtonConfig> = [];
  private acceptButton: ButtonConfig = { ...buttonsStaticConfig.yes, label: 'LBL_BTN.ACCEPT_ALL' };

  public disabledButtons$ = new BehaviorSubject<Array<KeyValue>>(null);
  private buttonInit$ = new BehaviorSubject<boolean>(true);

  public readonly fireEvent = new EventEmitter<string>();
  private readonly destroy$ = new Subject();
  public notificationItems: Array<SystemNotification>;
  public notificationItemIds: Array<number>;

  @ViewChild('textContainer', {static: false}) textContainer: ElementRef;

  @Output() private emitService = new EventEmitter();

  ngOnInit() {
    this.notificationItems = [...this.data.items];
    this.notificationItemIds =  this.notificationItems.map(item => item.id);

    this.buttons = this.data.showAll ? [this.acceptButton] : [buttonsStaticConfig.no, this.acceptButton];

    this.fireEvent.pipe(
      tap(() => {
        this.buttons = !this.notificationItems[0].isRead ? [this.acceptButton] : [];
        this.buttonInit$.next(true);
      }),
      takeUntil(this.destroy$)
    ).subscribe();

    this.buttonInit$.pipe(
      debounceTime(100),
      tap(() => {
        if(this.textContainer?.nativeElement?.scrollHeight > this.textContainer?.nativeElement?.clientHeight) {
          this.disabledButtons$.next([{key: 'approve', value: true}]);
          this.textContainer.nativeElement.scrollTop = 0;
        }else{
          this.disabledButtons$.next([{key: 'approve', value: false}]);
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public buttonEvent(event: string, id: Array<number>) {
    if(this.data.showAll){
      this.emitService.emit({event, id});
      this.dialogRef.close('allApproved');
    }else{
      this.dialogRef.close(event);
    }
  }

  public onScroll(event: any) {
    if (((event.target.scrollTop + event.target.clientHeight) * 1.05) >= event.target.scrollHeight) {
      this.disabledButtons$.next(null);
    }
  }

  public trackById = (_, item: SystemNotification) => item?.id;
}
